<script lang="ts">
	import logoImage from "../../../../core/assets/logo.svg";
	import { appName } from "../../../../core/schema/names/appName.js";
	import { nbspify } from "../../../../core/utils/nbspify";
	import type { WeddingFillingCardProps } from "../../templates/WeddingsProps";
	import DynamicPicture from "../Picture/DynamicPicture.svelte";
	import StaticPicture from "../Picture/StaticPicture.svelte";

	export let filling: WeddingFillingCardProps;
</script>

<div class="glide__slide">
	<div class="relative mx-auto h-[13.5rem] !w-[13.5rem] rounded-lg lg:h-[18rem] lg:!w-[18rem]">
		{#if filling.image}
			<DynamicPicture
				class="size-full overflow-hidden rounded-lg"
				imgClass="size-full rounded-lg object-cover"
				image={filling.image}
				width={288}
				height={288}
				bucket="storage"
				loading="lazy"
				alt="Fotografie – {filling.name}"
			/>
		{:else}
			<div class="flex size-full items-center justify-center rounded-lg bg-secondary-40">
				<StaticPicture alt="Logo {appName}" image={logoImage} class="opacity-50" width={96} height={96} />
			</div>
		{/if}
		<p
			class="absolute bottom-3 left-3 right-3 w-fit max-w-[calc(100%-(2*.75rem))] whitespace-normal rounded-lg bg-white px-3 py-[.3rem] text-2xs font-semibold lg:bottom-4 lg:left-4 lg:right-4 lg:max-w-[calc(100%-(2*1rem))] lg:text-base"
		>
			{nbspify(filling.name)}
		</p>
	</div>
</div>
